<script>

    import { pickupStore, adminStore } from '../stores'

    import { isPermission } from '../$methods/permissions.methods'

    import ButtonModal from '../$components/button.modal.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

</script>

<InfoCard subtitle="Recolección">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        <InfoField label="Estatus" icon="fas fa-info-circle" value={ $pickupStore.status } />
        <InfoField label="Folio" icon="fas fa-hashtag" value={ $pickupStore.folio } />
        <InfoField label="Proveedor" icon="fas fa-truck" value={ $pickupStore.provider } />
        <InfoField label="Guía" icon="fas fa-barcode" value={ $pickupStore.guide } />
        <InfoField label="Usuario" icon="fas fa-user" value={ $pickupStore.user.name } bold />
        <InfoField label="Email" icon="fas fa-envelope" value={ $pickupStore.user.email } />
        <InfoField label="Contenido" icon="fas fa-box-open" value={ $pickupStore.package.content } />
        <InfoField label="Precio" icon="fas fa-dollar-sign" value="${ $pickupStore.package.value }" />
        <InfoField label="Paquetes" icon="fas fa-boxes" value={ $pickupStore.packageTotal } />
        {#if $pickupStore.package.width}
            <InfoField label="Ancho" icon="fas fa-ruler-horizontal" value="{ $pickupStore.package.width } cm" />
        {/if}
        {#if $pickupStore.package.height}
            <InfoField label="Alto" icon="fas fa-ruler-vertical" value="{ $pickupStore.package.height } cm" />
        {/if}
        {#if $pickupStore.package.length}
            <InfoField label="Largo" icon="fas fa-ruler" value="{ $pickupStore.package.length } cm" />
        {/if}
        {#if $pickupStore.package.weight}
            <InfoField label="Peso" icon="fas fa-weight-hanging" value="{ $pickupStore.package.weight } kg" />
        {/if}
    </div>
</InfoCard>

<InfoCard subtitle="Dirección de recolección">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        <InfoField label="Contacto" icon="fas fa-user" value={ $pickupStore.location.contact } bold />
        <InfoField label="RFC" icon="fas fa-id-card" value={ $pickupStore.location.rfc } />
        <InfoField label="Corporación" icon="fas fa-building" value={ $pickupStore.location.corporate } />
        <InfoField label="Teléfono" icon="fas fa-phone" value={ $pickupStore.location.phone } />
        <InfoField label="Correo" icon="fas fa-envelope" value={ $pickupStore.location.email } />
        <InfoField label="Código postal" icon="fas fa-map-pin" value={ $pickupStore.location.zipcode } />
        <InfoField label="Estado" icon="fas fa-map" value={ $pickupStore.location.state } />
        <InfoField label="Ciudad" icon="fas fa-city" value={ $pickupStore.location.city } />
        <InfoField label="Municipio" icon="fas fa-map-marker" value={ $pickupStore.location.municipality } />
        <InfoField label="Colonia" icon="fas fa-map-marker" value={ $pickupStore.location.colony } />
        <InfoField label="Calle" icon="fas fa-road" value={ $pickupStore.location.street } size="full" />
        <InfoField label="Exterior" icon="fas fa-door-open" value={ $pickupStore.location.number } />
        <InfoField label="Interior" icon="fas fa-layer-group" value={ $pickupStore.location.apartment } />
        <InfoField label="Referencias" icon="fas fa-info-circle" value={ $pickupStore.location.references } size="full" />
    </div>
</InfoCard>

{#if isPermission($adminStore, 'TracingsView.Pickups.Update')}
    <div class="items-end">
        <ButtonModal modalId="pickup_update_modal" icon="edit" text="Actualizar" />
    </div>
{/if}
